import { ToggleButton, ToggleButtonGroup, OverlayTrigger, Tooltip } from "react-bootstrap";

interface ToggleStatsModeProps{
  setShowStats: (mode:string) => void;
  showStats: string;
}

function ToggleStatsMode(props:ToggleStatsModeProps) {
  const { showStats, setShowStats } = props;

  const handleStatsModeChange = (newStatsMode: string) => {
    setShowStats(newStatsMode);
  }

  return (
    <div style={{ margin: "10px 40px 10px 0", display: "flex", alignItems: "baseline" }}>
      <strong style={{ marginRight: "10px" }}>Show stats for: </strong>
      <ToggleButtonGroup type="radio" name="statsMode" value={showStats} onChange={handleStatsModeChange}>
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id="matched-campaigns-tooltip">Show stats only for the campaigns that match your search criteria</Tooltip>}
        >
          <ToggleButton 
            value="matched" 
            size="sm"
            variant={showStats === 'matched' ? 'primary' : 'secondary'}
          >
            Matching Campaigns
          </ToggleButton>
        </OverlayTrigger>
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id="all-campaigns-tooltip">Shows stats for all campaigns, both active and inactive, including campaigns not matching your search criteria.</Tooltip>}
        >
          <ToggleButton 
            value="overall" 
            size="sm"
            variant={showStats === 'overall' ? 'primary' : 'secondary'}
          >
            All Campaigns
          </ToggleButton>
        </OverlayTrigger>
      </ToggleButtonGroup>
    </div>
  );
}

export default ToggleStatsMode;